import request from "../request";
import qs from "query-string";

//获取组织架构
export function getOrganizationApi(id: number) {
  return request.get(`api/department/sub_list/` + id);
}
//获取下级部门
export function getChildDepartmentApi(id: number) {
  return request.get(`api/department/sub_list/${id}`);
}

//获取单聊会话列表

export function getchat_list(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/chat_list?` + query);
}

//获取单聊天内容
export function get_chart_cont(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/chat_list/show?` + query);
}
//获取群聊会话列表

export function getgroup_list(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/group_chat?` + query);
}
export function getgroup_list2(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/group_chat/list?` + query);
}
//获取群聊会话详情

export function getgroup_cont(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/group_chat/show?` + query);
}
//客户列表

export function getcustomer_list(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/customer?` + query);
}
//搜索内容

export function getsearch_cont(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/chat_list/search?` + query);
}

//搜索用户接口

export function getsearch_user(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/user?` + query);
}
//获取存档人员列表

export function getarchive_list(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/user/msg_audit?` + query);
}

//获取群聊信息
export function getgroup_info(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/group_chat/detail?` + query);
}

// 定位分页

export function getlocation_list(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/chat_list/locatePage?` + query);
}

//获取记录ai

export function getai_list(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/ai/completions`);
}
//对话账号 key 管理

export function getkey_list(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/ai_key?` + query);
}

//添加修改 key 管理

export function addkey_post(params: any) {
  return request.post(`api/ai_key`, params);
}

//删除 key 管理

export function deletekey_post(id: Number) {
  return request.delete(`api/ai_key/${id}`);
}
export function deleteprompt_post(id: Number) {
  return request.delete(`api/ai_prompt/${id}`);
}

//获取 ai 模型

export function getmodel_list() {
  return request.get(`api/ai/model`);
}

//获取prompt列表

export function getprompt_list(params: any) {
  const query = qs.stringify(params);
  return request.get(`api/ai_prompt?` + query);
}

//添加修改 prompt

export function addprompt_post(params: any) {
  return request.post(`api/ai_prompt`, params);
}

//对话配置

export function getconfig_list() {
  return request.get(`api/ai/config`);
}

//修改对话配置

export function updateconfig_post(params: any) {
  return request.post(`api/ai/config`, params);
}
//获取最新会话 id

export function getlast_id(chat_md5: any) {
  return request.get(`api/ai_chat/getSession?chat_md5=` + chat_md5);
}
//创建新的会话

export function create_session(params: any) {
  return request.post(`api/ai_chat/newSession`, params);
}
//获取聊天记录
  export function getchat_history(chat_md5: any) {
    return request.get(`api/ai_chat/record/` + chat_md5);
  }
//提交聊天记录
  export function postchat_history(params: any) {
    return request.post(`api/ai_chat/completions`, params);
  }